import { useState } from "react";
import axios from "../utils/axios";

const useInventory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = async (apiCall) => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await apiCall();
      return res.data;
    } catch (err) {
      const errMsg = err?.message || err || "Something went wrong";
      setError(errMsg);
      throw new Error(errMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    getAllMaterialStock: (payload) => request(() => axios.post("/material-stock/list", payload)),
    addPurchase: (payload) => request(() => axios.post("/purchase/add", payload)),
    updatePurchase: (id, payload) => request(() => axios.put(`/purchase/${id}`, payload)),
    getAllPurchase: (payload) => request(() => axios.post("/purchase/list", payload)),
    addIssue: (payload) => request(() => axios.post("/issue/add", payload)),
    updateIssue: (id, payload) => request(() => axios.put(`/issue/${id}`, payload)),
    getAllIssue: (payload) => request(() => axios.post("/issue/list", payload)),
    addReturn: (payload) => request(() => axios.post("/return/add", payload)),
    updateReturn: (id, payload) => request(() => axios.put(`/return/${id}`, payload)),
    getAllReturn: (payload) => request(() => axios.post("/return/list", payload)),
    addSale: (payload) => request(() => axios.post("/sale/add", payload)),
    updateSale: (id, payload) => request(() => axios.put(`/sale/${id}`, payload)),
    getAllSale: (payload) => request(() => axios.post("/sale/list", payload)),
    addStockAdjustment: (payload) => request(() => axios.post("/stock-adjustment/add", payload)),
    updateStockAdjustment: (id, payload) =>
      request(() => axios.put(`/stock-adjustment/${id}`, payload)),
    getAllStockAdjustments: (payload) =>
      request(() => axios.post("/stock-adjustment/list", payload)),
    exportInventoryReport: (module, fileType, payload) =>
      request(() =>
        axios.post(`/inventory-export/${module}/${fileType}`, payload, { responseType: "blob" }),
      ),
    getTransactionLogReport: (payload) =>
      request(() => axios.post("/inventory-reports/transaction-log", payload)),
    getMaterialStockReport: (payload) =>
      request(() => axios.post("/inventory-reports/material-stock", payload)),
    getUserStockReport: (payload) =>
      request(() => axios.post("/inventory-reports/user-stock", payload)),
    getLowStockReport: (payload) =>
      request(() => axios.post("/inventory-reports/low-stock", payload)),
    autoSearchUser: async (query) => {
      const res = await axios.post("/radius/raduser/auto-search", {
        filters: [
          {
            fieldName: "userName",
            fieldValue: query,
            op: "like",
            dataType: "string",
            condition: "or",
            isJoin: false,
          },
        ],
        pagination: {
          pageNumber: 1,
          pageSize: 50,
        },
        sortFields: [],
      });
      const list = res.data?.data || [];
      return list.map((item) => ({
        userName: item.label,
        radUserId: item.value,
      }));
    },
  };
};

export default useInventory;
